import { securedAxios } from "../lib/axios";
import urljson from "../lib/urljson";
import { build } from "../lib/masks";
import number_format from "../lib/number_format";
import { arredondarMoeda, somarMoeda } from "../lib/moeda";
import moment from "moment";

const DataBR = dataSql => {
  if (!dataSql) return null;

  const [year, month, day] = dataSql.split("-");
  return `${day}/${month}/${year}`;
};

export default {
  namespaced: true,
  state: {
    OrdemMedicao: [],
    OrdemMedicaoItens: [],
    dialogProgramacaoPagamento: null
  },
  mutations: {
    carregar(state, OrdemMedicao) {
      state.OrdemMedicao = [];
      state.OrdemMedicao = OrdemMedicao;
    },
    carregarItens(state, OrdemMedicaoItens) {
      state.OrdemMedicaoItens = [];
      state.OrdemMedicaoItens = OrdemMedicaoItens;
    },
    setProgramacaoPagamento(state, OrdemMedicao) {
      state.dialogProgramacaoPagamento = OrdemMedicao;
    }
  },
  actions: {
    async listar({ commit }, opcoes) {
      if (opcoes.filtros.id) {
        opcoes.filtros.id = parseInt(opcoes.filtros.id);
      }
      try {
        const response = await securedAxios.get(
          `/ordem?opcoes=${urljson(opcoes)}`
        );
        //console.log(response.data);
        commit("carregar", response.data);
        return Promise.resolve(response);
      } catch (e) {
        return Promise.reject(e);
      }
    },
    async gravar(context, ordemMedicaoInfo) {
      try {
        let response;
        if (ordemMedicaoInfo.id == "") {
          delete ordemMedicaoInfo.id;
          response = await securedAxios.post("/ordem", ordemMedicaoInfo);
        } else {
          var id = ordemMedicaoInfo.id;
          delete ordemMedicaoInfo.id;
          delete ordemMedicaoInfo.id_usuario_emissao;
          delete ordemMedicaoInfo.data_emissao;
          response = await securedAxios.put("/ordem/" + id, ordemMedicaoInfo);
        }

        return Promise.resolve(response.data);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    async gravarFatura(context, faturaInfo) {
      try {
        let response;
        if (faturaInfo.id_fatura == "") {
          delete faturaInfo.id_fatura;
          response = await securedAxios.post("/fatura", faturaInfo);
        } else {
          var id_fatura = faturaInfo.id_fatura;
          delete faturaInfo.id_fatura;
          response = await securedAxios.put("/fatura/" + id_fatura, faturaInfo);
        }

        return Promise.resolve(response.data);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    async gravarNota(context, notaInfo) {
      try {
        let response;
        const id_nota = notaInfo.get("id_nota");
        console.log(id_nota);
        notaInfo.delete("id_nota");
        if (id_nota == "") {
          response = await securedAxios.post("/nfs", notaInfo);
        } else {
          response = await securedAxios.put("/nfs/" + id_nota, notaInfo);
        }

        return Promise.resolve(response.data);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    async arquivoNota(context, idNota) {
      try {
        const response = await securedAxios.get(`nfs/${idNota}/arquivo`, {
          responseType: "blob"
        });
        return Promise.resolve(response.data);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    carregarOrdemMedicao(context, id) {
      return securedAxios.get(`/ordem/${id}`);
    },
    async deletar(context, id) {
      try {
        const response = securedAxios.delete("/ordem/" + id.id);
        return Promise.resolve(response);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    async carregarClientes(context, opcoes) {
      try {
        const response = await securedAxios.get(
          `/clientes?opcoes=${urljson(opcoes)}`
        );

        return Promise.resolve(response.data);
      } catch (e) {
        return Promise.reject(e);
      }
    },
    async carregarItens({ commit }, id_ordem) {
      try {
        const response = await securedAxios.get(`/ordem/${id_ordem}/item`);
        //console.log(response.data);
        commit("carregarItens", response.data);
        return Promise.resolve(response);
      } catch (e) {
        return Promise.reject(e);
      }
    },
    async carregarItem(context, { id_ordem, id_item }) {
      try {
        const response = await securedAxios.get(
          `/ordem/${id_ordem}/item/${id_item}`
        );
        //console.log(response.data);
        return Promise.resolve(response.data);
      } catch (e) {
        return Promise.reject(e);
      }
    },
    async sobeItem(context, ordemMedicaoInfo) {
      try {
        const response = await securedAxios.get(
          `/ordem/${ordemMedicaoInfo.id_ordem}/item/${ordemMedicaoInfo.id_ordem_item}/sobe`
        );
        //console.log(response.data);
        return Promise.resolve(response.data);
      } catch (e) {
        return Promise.reject(e);
      }
    },
    async desceItem(context, ordemMedicaoInfo) {
      try {
        const response = await securedAxios.get(
          `/ordem/${ordemMedicaoInfo.id_ordem}/item/${ordemMedicaoInfo.id_ordem_item}/desce`
        );
        //console.log(response.data);
        return Promise.resolve(response.data);
      } catch (e) {
        return Promise.reject(e);
      }
    },
    async carregarEquipamentos() {
      const opcoes = {filtros: {ativo: true}};
      return securedAxios.get(`/equipamento?opcoes=${urljson(opcoes)}`);
    },
    async gravarItem(context, ordemMedicaoInfo) {
      id_ordem_item;
      try {
        let response;
        var id_ordem = ordemMedicaoInfo.id_ordem;
        if (ordemMedicaoInfo.id_ordem_item == "") {
          delete ordemMedicaoInfo.id_ordem_item;
          response = await securedAxios.post(
            `/ordem/${id_ordem}/item`,
            ordemMedicaoInfo
          );
        } else {
          var id_ordem_item = ordemMedicaoInfo.id_ordem_item;
          delete ordemMedicaoInfo.id_ordem_item;
          delete ordemMedicaoInfo.sequencia;
          response = await securedAxios.put(
            `/ordem/${id_ordem}/item/` + id_ordem_item,
            ordemMedicaoInfo
          );
        }

        return Promise.resolve(response.data);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    deletarItem(context, Infos) {
      try {
        const response = securedAxios.delete(
          `/ordem/${Infos.id_ordem}/item/${Infos.id_item}`
        );
        return Promise.resolve(response);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    upItem(context, Infos) {
      try {
        const response = securedAxios.delete(
          `/ordem/${Infos.id_ordem}/item/${Infos.id_item}`
        );
        return Promise.resolve(response);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    downItem(context, Infos) {
      try {
        const response = securedAxios.delete(
          `/ordem/${Infos.id_ordem}/item/${Infos.id_item}`
        );
        return Promise.resolve(response);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    async buscarFaturaPorOrdem(context, opcoes) {
      try {
        const response = await securedAxios.get(
          `/fatura?opcoes=${urljson(opcoes)}`
        );
        return Promise.resolve(response);
      } catch (e) {
        return Promise.reject(e);
      }
    },
    async buscarNotaPorOrdem(context, opcoes) {
      try {
        const response = await securedAxios.get(
          `/nfs?opcoes=${urljson(opcoes)}`
        );
        return Promise.resolve(response);
      } catch (e) {
        return Promise.reject(e);
      }
    },
    async pdfOM({ dispatch }, id) {
      try {
        const response = await dispatch("carregarOrdemMedicao", id);
        if (response.data.data_medicao)
          response.data.data_medicao = DataBR(
            response.data.data_medicao.substr(0, 10)
          );

        if (response.data.data_emissao)
          response.data.data_emissao = DataBR(
            response.data.data_emissao.substr(0, 10)
          );

        if (response.data.data_devolucao)
          response.data.data_devolucao = DataBR(
            response.data.data_devolucao.substr(0, 10)
          );

        if (response.data.data_vencimento_programada)
          response.data.data_vencimento_programada = DataBR(
            response.data.data_vencimento_programada.substr(0, 10)
          );

        const ordemItens = await dispatch("carregarItens", id);

        var primeiraDataMedicao = "";
        const bvTerceiros = [];
        const totaisBVTerceiros = {};
        const observacoes = [];
        const terceiros = [];
        const bvs = [];

        const totalizador = {
          total_geral: 0,
          desconto: response.data.desconto,
          total_com_desconto: response.data.desconto * -1
        };

        for (let item of ordemItens.data) {
          if (item.data_medicao != null) {
            if (primeiraDataMedicao == "")
              primeiraDataMedicao = DataBR(item.data_medicao.substr(0, 10));

            item.data_medicao = DataBR(item.data_medicao.substr(0, 10));
          }

          if (item.hora_fim > 0 && item.hora_inicio > 0) {
            let totalMedido = item.hora_fim - item.hora_inicio;
            if (totalMedido < 10) totalMedido = 10;

            item.total_medido = number_format(totalMedido);
          } else item.total_medido = "-";

          if (item.horas_cobrar == null) item.horas_cobrar = 1;

          item.hora_inicio =
            item.hora_inicio > 0 ? number_format(item.hora_inicio) : "-";
          item.hora_fim =
            item.hora_fim > 0 ? number_format(item.hora_fim) : "-";

          if (item.observacao != "") {
            observacoes.push({
              data: item.data_medicao,
              observacao: item.observacao
            });
          }

          if (item.usado_terceiro) {
            var nomeTerceiro = item.nome_terceiro
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
              .toUpperCase();

            const subtotal = arredondarMoeda(
              item.valor_pagar * item.horas_cobrar
            );
            const descontoTerceiro = arredondarMoeda(item.desconto_terceiro);

            //------
            terceiros.push({
              data_medicao: item.data_medicao,
              nome_terceiro: nomeTerceiro,
              unidade_terceiro: item.unidade_terceiro.descricao,
              valor_pagar: number_format(subtotal),
              quantidade: number_format(item.horas_cobrar),
              subtotal: number_format(subtotal)
            });
            //-----

            bvTerceiros.push({
              data_medicao: item.data_medicao,
              nome: nomeTerceiro,
              unidade: item.unidade_terceiro.descricao,
              desconto: number_format(item.desconto_terceiro),
              quantidade: number_format(item.horas_cobrar),
              valor_pagar: number_format(item.valor_pagar),
              subtotal: number_format(subtotal)
            });

            if (!totaisBVTerceiros[nomeTerceiro]) {
              totaisBVTerceiros[nomeTerceiro] = {
                nome: nomeTerceiro,
                valor: 0,
                desconto: 0,
                total: 0
              };
            }
            totaisBVTerceiros[nomeTerceiro].valor = somarMoeda(
              totaisBVTerceiros[nomeTerceiro].valor,
              subtotal
            );
            totaisBVTerceiros[nomeTerceiro].desconto = somarMoeda(
              totaisBVTerceiros[nomeTerceiro].desconto,
              descontoTerceiro
            );
            totaisBVTerceiros[nomeTerceiro].total = somarMoeda(
              totaisBVTerceiros[nomeTerceiro].total,
              subtotal,
              -descontoTerceiro
            );
          }

          if (item.tem_bonificacao) {
            var nomeBv = item.nome_vendedor
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
              .toUpperCase();

            let valor = item.valor_bonificacao;
            if (item.tipo_bonificacao == "P") {
              valor = item.valor_cobrar * (item.valor_bonificacao / 100);
            }

            const subtotal = arredondarMoeda(valor * item.horas_cobrar);
            const descontoBv = arredondarMoeda(item.desconto_bv);

            //-----
            bvs.push({
              data_medicao: item.data_medicao,
              nome_vendedor_bv: nomeBv,
              unidade_bv: item.unidade_bv.descricao,
              valor_bv: number_format(subtotal),
              unidade: item.unidade_bv.descricao,
              quantidade: number_format(item.horas_cobrar),
              subtotal: number_format(subtotal)
            });
            //-----

            bvTerceiros.push({
              data_medicao: item.data_medicao,
              nome: nomeBv,
              unidade: item.unidade_bv.descricao,
              valor_pagar: number_format(valor),
              desconto: number_format(item.desconto_bv),
              quantidade: number_format(item.horas_cobrar),
              subtotal: number_format(subtotal)
            });

            if (!totaisBVTerceiros[nomeBv]) {
              totaisBVTerceiros[nomeBv] = {
                nome: nomeBv,
                valor: 0,
                desconto: 0,
                total: 0
              };
            }
            totaisBVTerceiros[nomeBv].valor = somarMoeda(
              totaisBVTerceiros[nomeBv].valor,
              subtotal
            );
            totaisBVTerceiros[nomeBv].desconto = somarMoeda(
              totaisBVTerceiros[nomeBv].desconto,
              descontoBv
            );
            totaisBVTerceiros[nomeBv].total = somarMoeda(
              totaisBVTerceiros[nomeBv].total,
              subtotal,
              -descontoBv
            );
          }

          const subtotalItem = arredondarMoeda(
            item.horas_cobrar * item.valor_cobrar
          );
          const descontoItem = arredondarMoeda(item.desconto_item);
          totalizador.total_geral = somarMoeda(
            totalizador.total_geral,
            subtotalItem
          );
          totalizador.desconto = somarMoeda(
            totalizador.desconto,
            descontoItem
          );
          totalizador.total_com_desconto = somarMoeda(
            totalizador.total_com_desconto,
            subtotalItem,
            -descontoItem
          );

          item.subtotal = number_format(subtotalItem);
          item.horas_cobrar = number_format(item.horas_cobrar);
          item.valor_cobrar = number_format(item.valor_cobrar);
        }

        const totais = [];
        Object.keys(totaisBVTerceiros).map(nome => {
          const total = totaisBVTerceiros[nome];
          total.valor = number_format(total.valor);
          total.desconto = number_format(total.desconto);
          total.total = number_format(total.total);
          totais.push(total);
        });

        response.data.programacao_pagamento = response.data.programacao_pagamento.map(
          prg => {
            return {
              valor: build.money(prg.valor),
              data: moment(prg.data).format("DD/MM/YYYY"),
              antecipado: prg.antecipado ? "Sim" : "Não"
            };
          }
        );

        response.data.observacoes = observacoes;
        response.data.itens = ordemItens.data;
        response.data.bvTerceiros = bvTerceiros;
        response.data.totaisBVTerceiros = totais;
        //----
        response.data.terceiros = terceiros;
        response.data.bvs = bvs;
        response.data.linhas_adicionais_terceiros =
          bvs.length > terceiros.length ? bvs.length - terceiros.length : 0;
        response.data.linhas_adicionais_bv =
          terceiros.length > bvs.length ? terceiros.length - bvs.length : 0;
        //---
        response.data.totalizador = {
          total_geral: number_format(totalizador.total_geral),
          desconto: number_format(totalizador.desconto),
          total_com_desconto: number_format(totalizador.total_com_desconto)
        };

        if (response.data.id_usuario_representante != null)
          response.data.data_hora_validacao_representante = DataBR(
            response.data.data_hora_validacao_representante.substr(0, 10)
          );
        if (response.data.id_usuario_diretoria_operacional)
          response.data.data_hora_diretoria_operacional = DataBR(
            response.data.data_hora_diretoria_operacional.substr(0, 10)
          );
        if (response.data.id_usuario_diretoria_financeiro)
          response.data.data_hora_diretoria_financeiro = DataBR(
            response.data.data_hora_diretoria_financeiro.substr(0, 10)
          );

        response.data.data_medicao = primeiraDataMedicao;
        response.data.mes_ano = primeiraDataMedicao.substr(3, 7);
        response.data.cliente.cpf_cnpj =
          response.data.cliente.tipo == "J"
            ? build.cnpj(response.data.cliente.cpf_cnpj)
            : build.cpf(response.data.cliente.cpf_cnpj);

        const rel = await dispatch(
          "relatorio/gerar",
          {
            template: "ordem-medicao.html",
            dados: {
              titulo: "OM - ORDEM DE MEDIÇÃO",
              dados: response
            }
          },
          { root: true }
        );
        return Promise.resolve(rel);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    async guardarDocumentos({ dispatch }, om) {
      try {
        const documentos = [];
        const responseFatura = await dispatch("buscarFaturaPorOrdem", {
          CarregarContasReceber: true,
          filtros: { id_ordem: om }
        });

        const responseNota = await dispatch("buscarNotaPorOrdem", {
          CarregarContasReceber: true,
          filtros: { id_ordem: om }
        });

        const p = [
          dispatch("pdfOM", om),
          dispatch("relatorio/gerarPreFatura", om, { root: true })
        ];

        if (responseFatura.data.length > 0) {
          p.push(dispatch("relatorio/gerarFatura", om, { root: true }));
          for (let cr of responseFatura.data[0].contasreceber) {
            if (cr.id_forma_pagamento == 1) {
              try {
                const respBol = await dispatch("boleto/arquivoBoleto", cr.id, {
                  root: true
                });
                documentos.push({
                  novo: true,
                  tipo_documento: { id: 51 },
                  registro: `${cr.documento}`,
                  id_tipo_documento: 51,
                  nome_original: `BOLETO - ${cr.documento}.pdf`,
                  arquivo: respBol
                });
              } catch (err) {
                console.log(err);
              }
            } 
          }
        }

        if (responseNota.data.length > 0) {
          try {
            const respDANFE = await dispatch(
              "arquivoNota",
              responseNota.data[0].id
            );
            documentos.push({
              novo: true,
              tipo_documento: { id: 55 },
              registro: `${responseNota.data[0].numero}`,
              id_tipo_documento: 55,
              nome_original: `${responseNota.data[0].numero}.pdf`,
              arquivo: respDANFE
            });
          } catch (err) {
            console.log(err);
          }

          for (let cr of responseNota.data[0].contasreceber) {
            if (cr.id_forma_pagamento == 1) {
              try {
                const respBol = await dispatch("boleto/arquivoBoleto", cr.id, {
                  root: true
                });
                documentos.push({
                  novo: true,
                  tipo_documento: { id: 51 },
                  registro: `${cr.documento}`,
                  id_tipo_documento: 51,
                  nome_original: `BOLETO - ${cr.documento}.pdf`,
                  arquivo: respBol
                });
              } catch (e) {
                console.log(e);
              }
            }
          }
        }

        const responses = await Promise.all(p);
        documentos.push({
          novo: true,
          tipo_documento: { id: 52 },
          registro: `OM - ${om}`,
          id_tipo_documento: 52,
          nome_original: `Ordem Medição - ${om}.pdf`,
          arquivo: responses[0].data
        });
        documentos.push({
          novo: true,
          tipo_documento: { id: 53 },
          registro: `OM - ${om}`,
          id_tipo_documento: 53,
          nome_original: `Ordem Medição - Cliente - ${om}.pdf`,
          arquivo: responses[1]
        });
        if (responses[2]) {
          documentos.push({
            novo: true,
            tipo_documento: { id: 54 },
            registro: `${responseFatura.data[0].numero}`,
            id_tipo_documento: 54,
            nome_original: `Fatura - ${responseFatura.data[0].numero}.pdf`,
            arquivo: responses[2]
          });
        }
        await dispatch(
          "documento/gravar",
          {
            urlBase: "ordem",
            IDProprietario: om,
            documentos
          },
          { root: true }
        );
        Promise.resolve(true);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    async totalOrdem({ dispatch }, om) {
      try {
        const response = await dispatch("carregarItens", om.id);

        let totalOrdem = arredondarMoeda(om.desconto) * -1;
        response.data.map(item => {
          const horas = item.horas_cobrar || 0;
          const subtotal = arredondarMoeda(item.valor_cobrar * horas);
          totalOrdem = somarMoeda(
            totalOrdem,
            subtotal,
            -arredondarMoeda(item.desconto_item)
          );
          return item;
        });
        return Promise.resolve(totalOrdem.toFixed(2));
      } catch (err) {
        return Promise.reject(err);
      }
    }
  }
};
